import React from 'react';
import { DeleteModal } from '../../../components/modals';

import { gql, useMutation } from '@apollo/client';
import { GET_POLICY_PRICINGS } from '../../policyPricing/hooks/usePolicyPricings';

const REMOVE_POLICY_RETAIL_COMMISSION = gql`
  mutation RemovePolicyRetailCommission($input: RemovePolicyRetailCommissionInput!) {
    removePolicyRetailCommission(input: $input) {
      id
      retailCommissions {
        id
        name
        rateMode
        rate
      }
    }
  }
`;

export default function Remove({ policyId, isOpen, toggle, retailCommission, onError = () => {} }) {
  const [remove, { loading: removing, error: removeError }] = useMutation(REMOVE_POLICY_RETAIL_COMMISSION, {
    variables: { input: { retailCommissionId: retailCommission?.id } },
    onCompleted: toggle,
    onError,
    refetchQueries: [{ query: GET_POLICY_PRICINGS, variables: { id: policyId } }]
  });

  return (
    <DeleteModal
      isOpen={isOpen}
      toggle={toggle}
      entityType="Retail Commission"
      entityName={retailCommission?.name}
      deleting={removing}
      error={removeError}
      onSubmit={remove}
    />
  );
}
